import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugin
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from './services/auth.service';
import { HttpClientModule , HttpClient } from '@angular/common/http';
import { InicioComponent } from './pages/inicio/inicio.component';
import { RasciComponent } from './pages/rasci/rasci.component';
import { CvComponent } from './pages/cv/cv.component';
import { MenuComponent } from './pages/menu/menu.component';
import { AreaComponent } from './pages/area/area.component';
import { ProcesoComponent } from './pages/proceso/proceso.component';
import { OrgComponent } from './pages/org/org.component';
import { RoleComponent } from './pages/role/role.component';

import { CommonModule } from '@angular/common';
import { NgxOrgChartModule } from 'ngx-org-chart';
import { RptPerComponent } from './pages/rpt-per/rpt-per.component';
import { ClienteComponent } from './pages/cliente/cliente.component';
import { CrmReportesComponent } from './pages/crm-reportes/crm-reportes.component';
import { CompetenciaComponent } from './pages/competencia/competencia.component';
import { Format1Component } from './pages/format1/format1.component';
import { Pformat1Component } from './pformat1/pformat1.component';
import { ServiciosComponent } from './pages/servicios/servicios.component';
import { FormatRaciComponent } from './pages/format-raci/format-raci.component';
import { TaketimeComponent } from './pages/taketime/taketime.component';
import { FormatServiceComponent } from './pages/format-service/format-service.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { Raci2Component } from './pages/raci2/raci2.component';
import { HkComponent } from './pages/hk/hk.component';
import { RegistroComponent } from './pages/registro/registro.component';
import { FmthkComponent } from './pages/fmthk/fmthk.component';
import { HojatrabajoComponent } from './pages/hojatrabajo/hojatrabajo.component';
import { AssesmentComponent } from './pages/assesment/assesment.component';
import { FmtcharterComponent } from './pages/fmtcharter/fmtcharter.component';
import { FmthtComponent } from './pages/fmtht/fmtht.component';
import { FmtdespliegueComponent } from './pages/fmtdespliegue/fmtdespliegue.component';
import { DespliegueComponent } from './pages/despliegue/despliegue.component'; 
import {HashLocationStrategy, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { DdfComponent } from './pages/ddf/ddf.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { UsuarioComponent } from './pages/usuario/usuario.component';
import { ClientesComponent } from './pages/clientes/clientes.component';
import { PreventaComponent } from './pages/preventa/preventa.component';
import { SeguimientoClienteComponent } from './pages/seguimiento-cliente/seguimiento-cliente.component';
import { TaskComponent } from './pages/task/task.component';
import { FmttaskComponent } from './pages/fmttask/fmttask.component';
import { GanttChartAngularModule } from 'gantt-chart-angular';
import { CelenComponent } from './pages/celen/celen.component';
import { CelenfmtComponent } from './pages/celenfmt/celenfmt.component';
import { RolecardComponent } from './pages/rolecard/rolecard.component';
import { PersonaComponent } from './pages/persona/persona.component';
import { OrganigramaComponent } from './pages/organigrama/organigrama.component';
import { EstructuraComponent } from './pages/estructura/estructura.component';
import { ListaClienteComponent } from './pages/lista-cliente/lista-cliente.component';
import { NuevoclienteComponent } from './pages/nuevocliente/nuevocliente.component';
import { ButtonModule } from 'primeng/button';
import { FmttaskminutaComponent } from './pages/fmttaskminuta/fmttaskminuta.component';
import { FmttaskpendientesComponent } from './pages/fmttaskpendientes/fmttaskpendientes.component';
import { TasktestComponent } from './pages/tasktest/tasktest.component';
import { Menu2Component } from './pages/menu2/menu2.component';
import { TicketComponent } from './pages/ticket/ticket.component';
import { Listaclientesv2Component } from './pages/listaclientesv2/listaclientesv2.component';
import { MasterpageComponent } from './pages/masterpage/masterpage.component';
import { MenuLateralComponent } from './pages/menu-lateral/menu-lateral.component';
import { HeaderComponent } from './pages/header/header.component';
import { SearchComponent } from './pages/search/search.component';
import { EmpleadosComponent } from './pages/empleados/empleados.component';
import { EntidadComponent } from './pages/entidad/entidad.component';
import { EscolaridadComponent } from './pages/escolaridad/escolaridad.component';
import { ProbatorioComponent } from './pages/probatorio/probatorio.component';
import { InstitucionComponent } from './pages/institucion/institucion.component';
import {DropdownModule} from 'primeng/dropdown';
import {TableModule} from 'primeng/table';
import { HtcliComponent } from './pages/htcli/htcli.component';
import { HkcliComponent } from './pages/hkcli/hkcli.component';
import { WscliComponent } from './pages/wscli/wscli.component';
import { CalendarTaskComponent } from './pages/calendar-task/calendar-task.component';
import { MenusoporteComponent } from './pages/menusoporte/menusoporte.component';
import { AtenderticketComponent } from './pages/atenderticket/atenderticket.component';
import { PerfilComponent } from './pages/perfil/perfil.component';
import { PginicioComponent } from './pages/pginicio/pginicio.component';
import { Frmdc3Component } from './pages/formas/frmdc3/frmdc3.component';
import { FmtcelenmisionComponent } from './pages/fmtcelenmision/fmtcelenmision.component';

import { Formatodc3Component } from './formatodc3/formatodc3.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FmtdiaComponent } from './pages/fmtdia/fmtdia.component';
import { FrmentrenamientoComponent} from './pages/formas/frmentrenamiento/frmentrenamiento.component'
import { FrmmultihabilidadComponent} from './pages/formas/frmmultihabilidad/frmmultihabilidad.component'
import {DialogModule} from 'primeng/dialog';
import {CheckboxModule} from 'primeng/checkbox'
import {TreeModule} from 'primeng/tree';
import {ContextMenuModule} from 'primeng/contextmenu';
import {MultiSelectModule} from 'primeng/multiselect'
import {TabMenuModule} from 'primeng/tabmenu';
import {MenuModule} from 'primeng/menu';
import { BaseComponent } from './pages/base/base.component';
import { Header2Component } from './pages/header2/header2.component';
import { DocumentofinalComponent } from './pages/documentofinal/documentofinal.component';
import { FmtdocumentofinalComponent } from './pages/fmtdocumentofinal/fmtdocumentofinal.component';
import { RacivdocComponent } from './pages/racivdoc/racivdoc.component';
import { HtvdocComponent } from './pages/htvdoc/htvdoc.component';
import { FrmmatpuecurComponent } from './pages/formas/frmmatpuecur/frmmatpuecur.component';
import { ListaDdfComponent } from './pages/lista-ddf/lista-ddf.component';
import { Ddf2Component } from './pages/ddf2/ddf2.component';
import { CursosComponent } from './pages/cursos/cursos.component';
import {InputTextModule} from 'primeng/inputtext';
import {InputNumberModule} from 'primeng/inputnumber';
import {TooltipModule} from 'primeng/tooltip';
import { ListaClienteLComponent } from './pages/leady/lista-cliente-l/lista-cliente-l.component';
import { InicioLeadyComponent } from './pages/leady/inicio-leady/inicio-leady.component';
import { OrgLComponent } from './pages/leady/org-l/org-l.component';

import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { NgxSpinnerModule } from "ngx-spinner";

//import { NgxGraphModule } from '@swimlane/ngx-graph'
FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin
]);


@NgModule({
  declarations: [
    AppComponent,
    UsuarioComponent,SeguimientoClienteComponent,
    LoginComponent,ClientesComponent,PreventaComponent,
    InicioComponent,FrmentrenamientoComponent,FrmmultihabilidadComponent,
    RasciComponent,Frmdc3Component,Formatodc3Component,
    CvComponent,
    MenuComponent,
    AreaComponent,
    ProcesoComponent,
    OrgComponent,FrmmatpuecurComponent,
    RoleComponent,
    RptPerComponent,
    ClienteComponent,
    CrmReportesComponent,
    CompetenciaComponent,
    Format1Component,
    Pformat1Component,
    ServiciosComponent,
    FormatRaciComponent,
    TaketimeComponent,
    FormatServiceComponent,
    Raci2Component,
    HkComponent,
    RegistroComponent,
    FmthkComponent,
    HojatrabajoComponent,
    AssesmentComponent,
    FmtcharterComponent,
    FmthtComponent,
    CalendarComponent,
    FmtdespliegueComponent,
    DespliegueComponent,
    DdfComponent,
    TaskComponent,
    FmttaskComponent,
    CelenComponent,
    CelenfmtComponent,
    RolecardComponent,
    PersonaComponent,
    OrganigramaComponent,
    EstructuraComponent,
    ListaClienteComponent,
    NuevoclienteComponent,
    FmttaskminutaComponent,
    FmttaskpendientesComponent,
    TasktestComponent,
    Menu2Component,
    TicketComponent,
    Listaclientesv2Component,
    MasterpageComponent,
    MenuLateralComponent,
    HeaderComponent,
    SearchComponent,
    EmpleadosComponent,
    EntidadComponent,
    EscolaridadComponent,
    ProbatorioComponent,
    InstitucionComponent,
    HtcliComponent,
    HkcliComponent,
    WscliComponent,
    CalendarTaskComponent,
    MenusoporteComponent,
    AtenderticketComponent,
    PerfilComponent,
    PginicioComponent,
    FmtcelenmisionComponent,
    FmtdiaComponent,
    BaseComponent,
    Header2Component,
    DocumentofinalComponent,
    FmtdocumentofinalComponent,
    RacivdocComponent,
    HtvdocComponent,
    ListaDdfComponent,
    Ddf2Component,
    CursosComponent,
    ListaClienteLComponent,
    InicioLeadyComponent,
    OrgLComponent
  ],
  imports: [
    PDFExportModule,NgxSpinnerModule,
    BrowserModule,CommonModule,BrowserAnimationsModule,   NgbModule,DropdownModule,TableModule,
    NgxOrgChartModule,NgApexchartsModule,FullCalendarModule,DialogModule,
    AppRoutingModule,FormsModule,HttpClientModule, GanttChartAngularModule,
    ButtonModule,CheckboxModule,TreeModule,ContextMenuModule,MultiSelectModule,
    TabMenuModule,MenuModule,InputTextModule,InputNumberModule,TooltipModule,
    
    //NgxGraphModule,
    BrowserAnimationsModule,
    
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
/*
angular.json
//,
              //"node_modules/primeicons/primeicons.css",
              "node_modules/primeng/resources/themes/lara-light-blue/theme.css",
              "node_modules/primeng/resources/primeng.min.css"
              
             */
